import { render, staticRenderFns } from "./budget-request.vue?vue&type=template&id=3499b0a2"
import script from "./budget-request.ts?vue&type=script&lang=ts&external"
export * from "./budget-request.ts?vue&type=script&lang=ts&external"
import style0 from "./budget-request.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3499b0a2')) {
      api.createRecord('3499b0a2', component.options)
    } else {
      api.reload('3499b0a2', component.options)
    }
    module.hot.accept("./budget-request.vue?vue&type=template&id=3499b0a2", function () {
      api.rerender('3499b0a2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/budget-request/budget-request.vue"
export default component.exports